import {IPpProductWizardOverviewData} from '../pp-product-wizard.types';
import {TemplateRef}                  from '@angular/core';
import {LoginStore}                   from '../../../../stores/login/login.store';
import {ApRoleTypeService}            from '../../../../services/common/ap-role-type.service';
import {ApDynformsConfigFieldset}     from '../../../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {nameOf}                       from '../../../../ap-core/utils/ap-name-of';
import {ApDynformsConfigTextbox}      from '../../../../ap-dynforms/config/ap-dynforms-config-textbox';
import {ApDynformsConfigTemplate}     from '../../../../ap-dynforms/config/ap-dynforms-config-template';

/**
 * PP-product wizard overview-tab ui logic provider
 */
export class PpProductWizardOverviewUiProvider {

  public static CreateFieldset(overviewData: IPpProductWizardOverviewData,
                               loginStore: LoginStore,
                               ppProductSelectedDetailsTemplate: TemplateRef<any>): ApDynformsConfigFieldset[] {
    const result: ApDynformsConfigFieldset[] = [];
    const countrySelection = ApRoleTypeService.hasAgriconRole(loginStore.User) ? [
      new ApDynformsConfigTextbox({
        key: nameOf<IPpProductWizardOverviewData>('CountryExpr'),
        label: 'Global__Country',
        disabled: true
      })
    ] : [];

    result.Add(new ApDynformsConfigFieldset({
      key: 'General',
      legend: overviewData?.ProductName,
      columns: countrySelection?.length > 0 ? 5 : 4,
      classList: 'informational-fieldset',
      config: [
        new ApDynformsConfigTextbox({
          key: nameOf<IPpProductWizardOverviewData>('PermissionStartExpr'),
          label: 'Docu_Ini__StartDate',
          disabled: true
        }),
        new ApDynformsConfigTextbox({
          key: nameOf<IPpProductWizardOverviewData>('PermissionEndExpr'),
          label: 'Docu_Ini__EndDate',
          disabled: true
        }),
        new ApDynformsConfigTextbox({
          key: nameOf<IPpProductWizardOverviewData>('UseByDateExpr'),
          label: 'Global__Expire_Date',
          disabled: true
        }),
        new ApDynformsConfigTextbox({
          key: nameOf<IPpProductWizardOverviewData>('WorkTypeExpr'),
          label: 'Docu_Ini__WorkType',
          disabled: true
        }),
        ...countrySelection
      ]
    }));

    result.Add(new ApDynformsConfigFieldset({
      key: 'Result',
      legend: 'Global__Result',
      hideLegend: true,
      classList: 'ap-field-set-no-legend-line',
      columns: 1,
      useMaxWidth: true,
      config: [
        new ApDynformsConfigTemplate({
          key: 'SelectedDetails',
          value: ppProductSelectedDetailsTemplate
        })
      ]
    }));

    return result;
  }
}
